<div class="datnek-ds-dialog-body dialog-delete-group">
  <div class="content-modal">
    <div class="notif-box p-3">
      <p>
        Voulez-vous vraiment supprimer le commentaire ? 
      </p>
    </div>
  </div>
  <div class="datnek-ds-dialog-footer">
    <datnek-ds-button
      [label]="'Annuler'"
      [size]="sizeEnum.large"
      [type]="colorEnum.secondary"
      class="mr-3"
      (datnekdsClickOrTouch)="close()"
    ></datnek-ds-button>
    <datnek-ds-button
      [label]="'Supprimer'"
      [size]="sizeEnum.large"
      [type]="colorEnum.danger"
      (datnekdsClickOrTouch)="close()"
    ></datnek-ds-button>
  </div>
</div>
